import FetchHelper from '../helpers/fetch_helper';

const FinancingProductsDispatcher = {
  async fetchPricingProgramNames() {
    try {
      const response = await FetchHelper.fetchJson('financing-products/pricing-program-names', { method: 'get' });
      this.setStoreVal('pricingProgramNames', response.results);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'Unable to get Pricing Program Names!' },
      });
    }
  },
};

export default FinancingProductsDispatcher;
